export function getWorkerUrl(name: string) {
  return (
    // NOTE: worker can not use publicPath because it must obey the same-origin policy.
    // `workerCacheKey` (appVersion + git SHA) changes per build so a rebuilt worker replaces the
    // running SharedWorker instance instead of being reused by a stale, version-only URL.
    (environment.subPath || '/') +
    'js/' +
    `${name}-${BUILD_CONFIG.workerCacheKey}.worker.js`
  );
}
